import { createContext } from 'react';
import { IFiltersState, DispatchFilters, FilterState } from './FiltersContext.types';
export const DefaultFilterState: IFiltersState = {
  curricula: {
    list: [],
    selectedId: null
  } as FilterState,
  courses: {
    list: [],
    selectedId: null
  } as FilterState,
  content: {},
  openAccordions: new Set(),
  filtersLoading: false
} as const;
export function getDefaultFilterState(): IFiltersState {
  return {
    ...DefaultFilterState
  };
}
export function getCachedContent<T>(content: {
  [key: string]: any;
}, key: string | null | undefined): T | undefined {
  if (key === null || key === undefined) {
    return undefined;
  }
  const cachedContent = content[key];
  return cachedContent ? cachedContent as T : undefined;
}
export const FiltersStateContext = createContext<IFiltersState>(DefaultFilterState);
export const FiltersDispatchContext = createContext<DispatchFilters | undefined>(undefined);